
export const Alert = ({message}) => {
  return (
    <div>
      <span>{message}</span>
    </div>
  )
}

